module.exports = __webpack_public_path__ + "static/media/ic_insert_drive_file_black_36px.0357d5a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_insert_drive_file_black_36px.svg
// module id = 793
// module chunks = 0